import { VEBEnrollmentSchema } from "../../types/enrollment.types";
import { api } from "../../utils/api";
type DependencyDialogLabels = {
	cancel: string;
	waive: string;
};

const dependencyMessage: Record<string, string> = {
	"critical illness":
		"You are ineligible for Critical Illness WITH CANCER Coverage Level as you have already enrolled for Cancer Plan.Either waive cancer plan or proceed without With Cancer Coverage Level",
	accident:
		"You are ineligible for Accident Disablity Riders as you have already enrolled for MedMutual Protect Short Term Disablity",
	"short term disability":
		"You have enrolled for disability coverage with your Accident Plan which prohibits you from electing Short-Term Disability coverage. To elect Short-Term Disability coverage, please waive your current disability rider on your Accident Plan. You are encouraged to review both plan benefits with a licensed benefits counselor so that you have an accurate understanding of how either policy would best serve you and your family"
};
// export const ENROLLMENT_DEPENDENCY_DIALOGPROP_LABEL: Record<string, string> = {
// 	"critical illness": "Proceed without Cancer coverage level"
// };
export const ENROLLMENT_DEPENDENCY_DIALOGPROP_LABEL: Record<string, DependencyDialogLabels> = {
	"critical illness": {
		cancel: "Proceed without Without Cancer coverage level",
		waive: "Waive Cancer Plan"
	},
	// accident: {
	// 	cancel: "Proceed without Critical Illness coverage level 123",
	// 	waive: "Waive Critical Illness Plan 123"
	// },
	"short term disability": {
		cancel: "cancle",
		waive: "Waive"
	},
	accident: {
		cancel: "Procide without disablity rider",
		waive: "Waive short term disability"
	}
};

export const DEPENDENCY_MESSAGE = dependencyMessage;
export type EnrollmentApiFn = () => Promise<VEBEnrollmentSchema | null>;

export const ENROLLMENT_API_MAP: Partial<Record<string, EnrollmentApiFn>> = {
	cancer: api.enrollment.getCancerEnrollment,
	accident: api.enrollment.getShortTermDisablityEnrollment,
	"short term disability": api.enrollment.getShortTermDisablityEnrollment,
	// "short term disability": api.enrollment.getAccidentDisablityRiderEnrollment,
	"disability income rider": api.enrollment.getAccidentDisablityRiderEnrollment

	// "critical illness": api.enrollment.getCriticalIllnessEnrollment
};
